import { useState, useCallback } from 'react';
import styles from './ConfirmPasswordModal.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import LockIcon from 'src/assets/icons/locksimple.svg?react';
import CheckIcon from 'src/assets/icons/left-check.svg?react';
import { useAuthToken } from '@hooks/useAuthToken';
import { TextInput, TextInputValue } from '@src/components/text-input/TextInput';
import { Lesson } from '@src/types';
import Spinner from '@src/components/spinner/Spinner';

type Props = {
  open: boolean;
  lesson?: Lesson;
  message?: string | undefined;
  closeButton?: boolean;
  loading?: boolean;
  onConfirmPassword: () => void;
  onClose: () => void;
};

function ConfirmPasswordModal(props: Props) {
  const { open, onConfirmPassword, onClose, message, closeButton=true, loading } = props;
  const [ repassword, setRePassword ] = useState('');
  const [ beError, setBeError ] = useState('');
  const { password: authPassword } = useAuthToken();

  const handleClose = () => {
    onClose();
  };

  const handleConfirmPassword = useCallback(() => {
    if (repassword && authPassword) {
      if (repassword === authPassword) {
        onConfirmPassword();
      } else {
        setBeError('Incorrect password');
        return;
      }
    }
    setBeError('');
  }, [setBeError, authPassword, repassword, onConfirmPassword])

  const handleChangeText = useCallback(() => (value: TextInputValue) => {
    setRePassword(value.toString())
    setBeError('');
  }, []);

  return (
    <Modal open={open} onClose={handleClose} className={styles.passwordWrapper} closeOnOverlayClick={false} closeButton={closeButton}>
      <div>
        <LockIcon width={44} height={44} />
        <div className={styles.title}>
          { message ? message : 'Please enter your Account Password to Approve this Lesson:'}
        </div>
        <div className={styles.passwordContent}>
          <TextInput allowSpecialCharacters id="verifyPassword" hasError={false} subTitle={''} type="password"  placeholder={'Type your password'} value={repassword} label={''} onChange={handleChangeText()} />
        </div>
        {Boolean(beError) && <div className={styles.error}>{beError}</div>}
        <div className={styles.buttonAction}>
          <Button size="small" leftIcon={ loading ? <Spinner width={20} height={20} /> : <CheckIcon width={20} height={18}/>} className={ repassword.length < 8 ? styles.confirmDisalbeButton : styles.confirmCompletion} onClick={handleConfirmPassword} label={'Continue'}/>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmPasswordModal;
